/**
 * Manual audit-field catalog overrides merged on top of the generated catalog.
 * Use when Mongoose cannot infer a ref/enum (string FK, polymorphic id, etc.).
 */

/** Extra ref keys that are not in REFERENCE_REGISTRY but have a Mongoose model. */
export const AUDIT_REF_MODEL_ALIASES = Object.freeze({
    ticket: 'Ticket',
    dpiaAssessment: 'DpiaAssessment',
    surveyDefinition: 'SurveyDefinition',
    formSubmission: 'FormSubmission',
    privacyNotice: 'PrivacyNotice',
});

/**
 * @type {Record<string, Record<string, { kind?: string, refEntity?: string, values?: string[], labelKey?: string }>>}
 */
export const AUDIT_FIELD_CATALOG_OVERRIDES = Object.freeze({
    problem: {
        relatedTicket: { kind: 'ref', refEntity: 'ticket' },
        relatedTicketId: { kind: 'ref', refEntity: 'ticket' },
        serviceCatalogItem: { kind: 'ref', refEntity: 'serviceCatalogItem' },
        rootCause: { kind: 'ref', refEntity: 'rootCause' },
    },
    ticket: {
        category: { kind: 'ref', refEntity: 'ticketCategory' },
        sla: { kind: 'ref', refEntity: 'ticketSLA' },
        serviceCatalogItem: { kind: 'ref', refEntity: 'serviceCatalogItem' },
        linkedProblem: { kind: 'ref', refEntity: 'problem' },
        assignedTo: { kind: 'ref', refEntity: 'user' },
    },
    incident: {
        linkedProblem: { kind: 'ref', refEntity: 'problem' },
        assignedTo: { kind: 'ref', refEntity: 'user' },
    },
    asset: {
        category: { kind: 'ref', refEntity: 'assetCategory' },
        assetCategory: { kind: 'ref', refEntity: 'assetCategory' },
        assetGroup: { kind: 'ref', refEntity: 'assetGroup' },
        unit: { kind: 'ref', refEntity: 'unit' },
        owner: { kind: 'ref', refEntity: 'user' },
        custodian: { kind: 'ref', refEntity: 'user' },
    },
    document: {
        documentType: { kind: 'ref', refEntity: 'documentType' },
        classification: { kind: 'ref', refEntity: 'classification' },
    },
    action: {
        verifiedBy: { kind: 'ref', refEntity: 'user' },
        assignmentTemplate: { kind: 'ref', refEntity: 'assignmentTemplate' },
    },
});
